
export const EQueryToasts = {
    link_discord_success: "Successfully linked your Discord account",
    link_discord_error: "Error linking your account with Discord",
    link_steam_success: "Successfully linked your Steam account",
    link_steam_error: "Error linking your account with Steam",
    link_dlive_success: "Successfully linked your DLive account",
    link_dlive_error: "Error linking your account with DLive"
}
